import http from '@/utils/http';
import axios from 'axios';
import i18n from '@/main';

const URL_BASE = '/contrato-originacao';
const URL_BASE_TERRITORIO = '/territorios';

export default {
    buscarContratosNaoEnviados({ pagina, ordenacao, tamanho }) {
        return http.get({
            url:
                URL_BASE +
                `/empresa/nao-enviados?page=${
                    pagina - 1
                }&sort=${ordenacao}&size=${tamanho}`,
            lockScreen: false
        });
    },

    buscarContratoOriginacao(id) {
        return http.get({
            url: URL_BASE + '/empresa/visualizar/' + id,
            lockScreen: true
        });
    },

    buscarDetalheAnalise(numeroContrato, idTerritorio) {
        return http.get({
            url:
                URL_BASE +
                '/subempresa/detalhe-analise/' +
                numeroContrato +
                '/' +
                idTerritorio,
            lockScreen: true
        });
    },

    buscarRegionais() {
        return http.get({
            url: '/regional',
            lockScreen: false
        });
    },

    buscarCulturas() {
        return http.get({
            url: URL_BASE + '/material',
            lockScreen: false
        });
    },

    buscarSafras() {
        return http.get({
            url: URL_BASE + '/safra',
            lockScreen: false
        });
    },

    buscarBpClientes() {
        return http.get({
            url: URL_BASE + '/bp-cliente',
            lockScreen: false
        });
    },

    buscarFornecedores() {
        return http.get({
            url: '/fornecedor',
            lockScreen: false
        });
    },

    buscarCnpjFornecedores() {
        return [
            {
                label: 'CRIAR BACKEND',
                valor: 1
            }
        ];
    },

    buscarSegmentos() {
        return http.get({
            url: URL_BASE + '/segmento',
            lockScreen: false
        });
    },

    buscarCanais() {
        return http.get({
            url: URL_BASE + '/canal',
            lockScreen: false
        });
    },

    buscarPessoa(codigoTipoPessoa) {
        return http.get({
            url: URL_BASE + `/pessoas/${codigoTipoPessoa}`,
            lockScreen: false
        });
    },

    cadastrarManualmente({
        numeroContrato,
        idMaterial,
        idSafra,
        volumeContratado,
        volumeRecebido,
        valorDataContrato,
        idBpCliente,
        idSubEmpresa,
        subEmpresaCnpj,
        idSegmento,
        idCanal,
        idRegional,
        idMunicipio,
        idGerenteComercial,
        idGestorTerritorial,
        idGerenteRegional
    }) {
        return http.post({
            url: URL_BASE + '/empresa/inserir',
            data: {
                numeroContrato,
                idMaterial,
                idSafra,
                volumeContratado,
                volumeRecebido,
                valorDataContrato,
                idBpCliente,
                idSubEmpresa,
                subEmpresaCnpj,
                idSegmento,
                idCanal,
                idRegional,
                idMunicipio,
                idGerenteComercial,
                idGestorTerritorial,
                idGerenteRegional
            },
            lockScreen: false
        });
    },

    cadastrarViaPlanilha(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/empresa/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    cadastrarTerritoriosViaPlanilha(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            URL_BASE +
            '/subempresa/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    removerContrato(numeroContrato) {
        return http.put({
            url: URL_BASE + `/empresa/remover/${numeroContrato}`,
            data: {},
            lockScreen: true,
            lockMessage: `${i18n.t('mensagens.sistema.removendoContrato')} ${numeroContrato}`
        });
    },

    enviarContratos() {
        return http.get({
            url: URL_BASE + '/empresa/enviar-contratos',
            lockScreen: true
        });
    },

    dadosContratoSubempresa(numeroContrato) {
        return http.get({
            url: URL_BASE + '/subempresa/dados-gerais/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosGeraisDeContratos')
        });
    },

    inserirDadosContrato(data) {
        return http.post({
            url: URL_BASE + '/subempresa/inserir',
            data: data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoDadosDeContrato')
        });
    },

    findAll(search) {
        return http.get({
            url:
                URL_BASE_TERRITORIO +
                `/buscaTerritorioPaginado?searchText=${search}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarVisualizarProcessamentoSubEmpresa({ numeroContrato }) {
        return http.get({
            url: URL_BASE + `/subempresa/visualizar/${numeroContrato}`,
            lockScreen: true
        });
    },

    buscarTerritoriosVisualizarProcessamentoContratoSubEmpresa({
        contrato,
        pagina,
        tamanho,
        buscarTerritoriosComRestricao
    }) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/${contrato}?page=${pagina}&size=${tamanho}&territoriosComRestricoes=${buscarTerritoriosComRestricao}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarDadosContratosOriginacao({
        numeroContrato,
        page,
        size,
        territoriosComRestricoes
    }) {
        return http.get({
            url:
                URL_BASE +
                `/subempresa/${numeroContrato}?page=${page}&size=${size}&territoriosComRestricoes=${territoriosComRestricoes}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeContrato')
        });
    },

    removerTerritorioContratoSubEmpresa(numeroContrato, idTerritorio) {
        return http.post({
            url:
                URL_BASE +
                `/subempresa/remover/${numeroContrato}/${idTerritorio}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    concluirProcessamentoContratoSubempresa({ contrato }) {
        return http.get({
            url: URL_BASE + `/subempresa/concluir-processamento/${contrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },

    exportarRelatorioContratoEmpresa(numeroContrato) {
        return http.get({
            url: URL_BASE + `/empresa/exportar-relatorio/${numeroContrato}`,
            lockScreen: false
        });
    },

    verificaConcluir(numeroContrato) {
        return http.get({
            url: URL_BASE + '/subempresa/verifica-concluir/' + numeroContrato,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.verificandoSeOContratoPodeSerConcluido')
        });
    },

    buscarDadosLoteEmpresa() {
        return http.get({
            url: URL_BASE + '/empresa/lote',
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url:
                        URL_BASE + `/empresa/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarCpfCnpjFornecedor(id) {
        return http.get({
            url: `/fornecedor/${id}/cpfcnpj`,
            lockScreen: false
        });
    }
};
